(() => {
  if (customElements.get('almond-events')) return;
  class AlmondEvents extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.ready) this.init(); });
    }
    parse(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const [y, m, d] = value.split('-').map(Number);
      if (y < 1900 || y > 2200) return null;
      const date = new Date(y, m - 1, d, 12);
      return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d ? date : null;
    }
    init() {
      this.ready = true;
      this.events = [...this.querySelectorAll('[data-event]')].map(el => ({el, date: this.parse(el.dataset.date)}));
      this.events.sort((a, b) => (a.date?.getTime() ?? Infinity) - (b.date?.getTime() ?? Infinity));
      const list = this.querySelector('.ae__list');
      this.events.forEach(event => {
        list.append(event.el);
        if (event.date) event.el.querySelector('time').textContent = event.date.toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'});
        else event.el.querySelector('time').removeAttribute('datetime');
      });
      if (this.dataset.layout !== 'calendar') return;
      const today = new Date(); today.setHours(0,0,0,0);
      const first = this.events.find(event => event.date >= today)?.date || today;
      this.month = new Date(first.getFullYear(), first.getMonth(), 1, 12);
      this.querySelector('.ae__calendar').hidden = false;
      this.querySelector('[data-prev]').onclick = () => this.move(-1);
      this.querySelector('[data-next]').onclick = () => this.move(1);
      this.onSelect = event => {
        const item = this.events.find(item => item.el.dataset.shopifyEditorBlock && JSON.parse(item.el.dataset.shopifyEditorBlock).id === event.detail.blockId);
        if (item?.date) { this.month = new Date(item.date.getFullYear(), item.date.getMonth(), 1, 12); this.render(); }
      };
      document.addEventListener('shopify:block:select', this.onSelect);
      this.render();
    }
    move(step) { this.month.setMonth(this.month.getMonth() + step); this.render(); }
    render() {
      const y = this.month.getFullYear(), m = this.month.getMonth();
      this.querySelector('[data-month]').textContent = this.month.toLocaleDateString('en-US', {month:'long', year:'numeric'});
      const grid = this.querySelector('[data-grid]'); grid.replaceChildren();
      const count = new Date(y, m + 1, 0).getDate(), offset = this.month.getDay();
      const today = new Date();
      const visible = this.events.filter(event => event.date?.getFullYear() === y && event.date?.getMonth() === m);
      this.events.forEach(event => { event.el.hidden = !!event.date && !visible.includes(event); });
      this.querySelector('[data-empty]').hidden = visible.length > 0;
      for (let i = 0; i < Math.ceil((count + offset) / 7) * 7; i++) {
        const cell = document.createElement('div'); cell.className = 'ae__day';
        const day = i - offset + 1;
        if (day < 1 || day > count) { cell.classList.add('ae__day--blank'); cell.setAttribute('aria-hidden','true'); }
        else {
          const number = document.createElement('span'); number.textContent = day; cell.append(number);
          if (today.getFullYear() === y && today.getMonth() === m && today.getDate() === day) cell.classList.add('ae__day--today');
          visible.filter(event => event.date.getDate() === day).forEach(event => {
            const a = document.createElement('a'); a.href = '#' + event.el.id;
            a.textContent = event.el.querySelector('[data-title]').textContent;
            a.setAttribute('aria-label', a.textContent + ', ' + event.date.toLocaleDateString('en-US', {month:'long', day:'numeric', year:'numeric'}));
            a.onclick = e => { e.preventDefault(); event.el.scrollIntoView({block:'start'}); event.el.focus({preventScroll:true}); };
            cell.append(a);
          });
        }
        grid.append(cell);
      }
    }
    disconnectedCallback() { if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect); this.ready = false; }
  }
  customElements.define('almond-events', AlmondEvents);
})();
